<template>
  <div class="wrapper">
    <side-bar>
      <mobile-menu slot="content"></mobile-menu>

      <sidebar-link to="/dashboard">
        <i class="nc-icon nc-chart-pie-35"></i>
        <p>Inicio</p>
      </sidebar-link>
      <sidebar-link to="/dashboard/clienttasks">
        <i class="nc-icon nc-notes"></i>
        <p>Mis procesos</p>
      </sidebar-link>
      <sidebar-link to="/dashboard/clientaccount">
        <i class="nc-icon nc-circle-09"></i>
        <p>Mi cuenta</p>
      </sidebar-link>
      <sidebar-link to="/dashboard/comparecientes">
        <i class="nc-icon nc-bullet-list-67"></i>
        <p>Mis comparecientes</p>
      </sidebar-link>
      <sidebar-link to="/dashboard/monedero" v-if="rol === 'Cliente Administrador'">
        <i class="nc-icon nc-credit-card"></i>
        <p>Monedero</p>
      </sidebar-link>
      <sidebar-link to="/dashboard/videoteca">
        <i class="nc-icon nc-button-play"></i>
        <span>Videoteca</span>
      </sidebar-link>
      <hr />
      <div>
        <li class="nav-item">
          <a href="#" class="nav-link" @click.prevent="logout"> Cerrar sesión </a>
        </li>
      </div>
    </side-bar>

    <div class="main-panel">
      <dashboard-content @click="toggleSidebar"></dashboard-content>
      <content-footer></content-footer>
    </div>
  </div>
</template>
<script>
import ContentFooter from "@/layout/ContentFooter.vue";
import MobileMenu from "@/layout/MobileMenu.vue";
import DashboardContent from "@/views/clients/dashboard_content/DashboardContent.vue";

import Storage from "@/utils/storage";

const storage = new Storage();

export default {
  name: "DashboardClients",

  components: {
    ContentFooter,
    DashboardContent,
    MobileMenu
  },

  data() {
    return {
      rol: storage.getItem("role"),
      // logged: storage.getItem("logged")
    };
  },

  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },

    logout() {
      storage.removeItem("role");
      storage.removeItem("logged");
      storage.removeItem("accessToken");

      this.role = null;
      this.logged = false;

      this.$router.push("/");
    }
  }
};
</script>

<style scoped>
#logOu:hover {
  box-shadow: rgba(0, 0, 0, 0.17) 0px -23px 25px 0px inset,
    rgba(0, 0, 0, 0.15) 0px -36px 30px 0px inset,
    rgba(0, 0, 0, 0.1) 0px -79px 40px 0px inset, rgba(0, 0, 0, 0.06) 0px 2px 1px,
    rgba(0, 0, 0, 0.09) 0px 4px 2px, rgba(0, 0, 0, 0.09) 0px 8px 4px,
    rgba(0, 0, 0, 0.09) 0px 16px 8px, rgba(0, 0, 0, 0.09) 0px 32px 16px;
}

.abajo {
  text-align: center;
  /* position: absolute;
  bottom: 0; */
  position: relative;
  margin-top: 100%;
  text-size-adjust: 12px;
}
</style>
